import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setHasAffiliateSystem, setSupportedLanguages } from 'src/redux/slices/marketplaceConfig';

const useIframeHandshake = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.parent.postMessage({ type: 'IFRAME_READY' }, '*');
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'INIT_MARKETPLACE') {
        dispatch(setSupportedLanguages(event.data.languages));
        dispatch(setHasAffiliateSystem(event.data.hasAffiliateSystem));
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [dispatch]);
};

export default useIframeHandshake;
